// Dashboard
export const DASHBOARD_SELECTOR = 'dashboard-onboarding';
export const MOBILE_DASHBOARD_SELECTOR = 'mobile-dashboard-onboarding';

// Files
export const FILES_SELECTOR = 'files-onboarding';
export const MOBILE_FILES_SELECTOR = 'mobile-files-onboarding';

// Members
export const MEMBERS_ONE_SELECTOR = 'members-onboarding-one';
export const MOBILE_MEMBERS_ONE_SELECTOR = 'mobile-members-onboarding-one';

export const MEMBERS_TWO_SELECTOR = 'members-onboarding-two';
export const MOBILE_MEMBERS_TWO_SELECTOR = 'mobile-members-onboarding-two';

// Waiting room

export const WAITING_ROOM_SELECTOR = 'waiting-room-onboarding';
export const MOBILE_WAITING_ROOM_SELECTOR = 'mobile-waiting-room-onboarding';

// Settings
export const SETTINGS_ONE_SELECTOR = 'settings-onboarding-one';
export const SETTINGS_TWO_SELECTOR = 'settings-onboarding-two';
export const SETTINGS_THREE_SELECTOR = 'settings-onboarding-three';

export const MOBILE_SETTINGS_SELECTOR = 'mobile-settings-onboarding';

// Secure links
export const SECURE_LINKS_SELECTOR = 'secure-links-onboarding';
export const MOBILE_SECURE_LINKS_SELECTOR = 'mobile-secure-links-onboarding';

// QA
export const QA_SELECTOR = 'qa-onboarding';
export const MOBILE_QA_SELECTOR = 'mobile-qa-onboarding';

// Analytics
export const ANALYTICS_SELECTOR = 'analytics-onboarding';
export const MOBILE_ANALYTICS_SELECTOR = 'mobile-analytics-onboarding';

// RFI
export const RFI_SELECTOR = 'rfi-onboarding';
export const MOBILE_RFI_SELECTOR = 'mobile-rfi-onboarding';

// NDA
export const NDA_SELECTOR = 'nda-onboarding';
export const MOBILE_NDA_SELECTOR = 'mobile-nda-onboarding';
